"use client";

import React from "react";
import SectionBadge from "@/components/ui/section-badge";
import BlogCard from "@/components/ui/blog-card";
import ContentCarousel from "@/components/ui/content-carousel";

const advantages = [
  {
    title: "Zero Setup Required",
    description:
      "Start automating instantly with no coding or complex configuration needed; FillApp works directly in your browser using your existing sessions.",
    imageUrl: "/assets/images/zero-setup.png",
  },
  {
    title: "Secure by Design",
    description:
      "Runs in your environment without sharing credentials or monitoring in the background, ensuring your data stays private and under your control.",
    imageUrl: "/assets/images/secure.png",
  },
  {
    title: "Multi-Tab Execution",
    description:
      "Handles workflows across multiple tabs seamlessly, switching context only when necessary to minimize disruption to your current work.",
    imageUrl: "/assets/images/multi-tab.png",
  },
  {
    title: "Adaptive Speed Optimization",
    description:
      "Learns interaction patterns during tasks and batches similar steps for faster completion, accelerating repetitive actions over time.",
    imageUrl: "/assets/images/adaptive.png",
  },
  {
    title: "Transparent and Controllable",
    description:
      "Provides full visibility into actions with logs and guardrails like confirmations for sensitive steps, giving you complete oversight.",
    imageUrl: "/assets/images/transparent.png",
  },
];

export default function AdvantagesSection({
  className,
}: {
  className?: string
}) {
  return (
    <div id="advantages" className="w-full bg-background pt-14">
      <section className={`mx-auto flex w-full max-w-container px-6 ${className}`}>
        <div className="flex w-full flex-col gap-4">
          <div className="flex flex-col items-center gap-4">
            <SectionBadge>Advantages</SectionBadge>
            <h2 className="text-center font-medium text-3xl text-foreground tracking-tight lg:text-6xl md:text-5xl">
              How FillApp stands <br />out from other AI agents
            </h2>
          </div>

          <div className="py-12">
            <ContentCarousel
              items={advantages}
              renderItem={(advantage) => (
                <BlogCard
                  title={advantage.title}
                  description={advantage.description}
                  imageUrl={advantage.imageUrl}
                  aspectRatio="square"
                />
              )}
            />
          </div>
        </div>
      </section>
    </div>
  );
}
